import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid2,
  Typography,
  Button as MatButton,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../shared/PageHeader/PageHeader";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import Button from "../../../../components/Button/Button";
import ViewTableWrapper from "../../../../shared/ViewTableWrapper/ViewTableWrapper";
import { useEffect, useState } from "react";
import UpcomingInterviewCalendar from "./components/UpcomingInterviewCalendar";
import { getUser } from "../../../../utils/types";
import API from "../../../../api/axios";

const breadcrumbs: BreadcrumbsModel[] = [
  { name: "Candidate Management", route: "/admin/candidate-management" },
  { name: "View Candidate" },
];

// Define default interviewers data

const CandidateManagementCalenderView = () => {
  const navigate = useNavigate();
  const [switchView, setSwitchView] = useState<string>("calendar");
  const loggedUserdata = getUser();
  const state = useLocation();
  const [calenderData, setCalenderData] = useState<any>([]);
  const handleMenuOpen = (setAnchor: any) => (event: any) => {
    setAnchor(event.currentTarget);
  };

  const switchInterviewHandler = (type?: any) => setSwitchView(type);

  const handleCalenderViewActionClick = (data: any) => {
    navigate("/admin/candidate-management/view/upcoming-interview", {
      state: { ...state, calenderData: { ...data }, view: "calender" },
    });
  };

  const handleRescheduleActionClick = (data: any) => {
    navigate("/admin/candidate-management/view/reschedule-interview", {
      state: { ...state, reschduleData: { ...data }, view: "calender" },
    });
  };

  const getCalenderData = async () => {
    try {
      let response = await API.post("/interview/candidate/calendar", {
        candidate_id: state?.state?.id,
        offset: 0,
        limit: -1,
        viewType: "calendar",
      });
      let newData = response?.data?.data?.map((value: any) => {
        return {
          id: value?.id,
          title: value?.position_name,
          start: `${value?.slot_date}T${value?.start_time}`,
          end: `${value?.slot_date}T${value?.end_time}`,
          extendedProps: {
            position: value?.position_name,
            link: value?.webex_link,
            ...value,
          },
        };
      });
      setCalenderData(newData);
    } catch (error) {
      // Failed to fetch calendar data
    } finally {
    }
  };

  useEffect(() => {
    getCalenderData();
  }, []);

  return (
    <PageWrapper>
      <PageHeader breadcrumbs={breadcrumbs} title="View Candidate">
        <Button
          variant="secondary"
          variantType="contained"
          label="Back"
          onClick={() => navigate("/admin/candidate-management")}
        />
      </PageHeader>
      <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
        <CardContent>
          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }} marginBottom={4}>
              <Typography variant="body1">Candidate Name</Typography>
              <Typography variant="subtitle2">{`${
                state?.state?.first_name || "NA"
              } ${state?.state?.last_name || ""}`}</Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }} marginBottom={4}>
              <Typography variant="body1">Email</Typography>
              <Typography variant="subtitle2">
                {state?.state?.email || "NA"}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }} marginBottom={4}>
              <Typography variant="body1">Mobile</Typography>
              <Typography variant="subtitle2">
                {state?.state?.mobile || "NA"}
              </Typography>
            </Grid2>
            {/* <Grid2 size={{xs: 12, sm: 6, md: 4}} marginBottom={4}>
              <Typography variant="body1">State</Typography>
              <Typography variant="subtitle2">Tamilnadu</Typography>
            </Grid2>
            <Grid2 size={{xs: 12, sm: 6, md: 4}} marginBottom={4}>
              <Typography variant="body1">District</Typography>
              <Typography variant="subtitle2">Dindigul</Typography>
            </Grid2>
            <Grid2 size={{xs: 12, sm: 6, md: 4}} marginBottom={4}>
              <Typography variant="body1">INFRACON status</Typography>
              <Typography variant="subtitle2">Verified</Typography>
            </Grid2> */}
          </Grid2>

          <Box marginTop={5}>
            <ViewTableWrapper>
              <ViewTableWrapper.Header title="Upcoming Interviews"></ViewTableWrapper.Header>
              <Divider />
              <ViewTableWrapper.Content>
                <UpcomingInterviewCalendar
                  data={calenderData}
                  combinedButton={true}
                  handleCombinedButton={handleRescheduleActionClick}
                  combinedButtonText={
                    loggedUserdata?.roles?.role_code == "administrator"
                      ? "View"
                      : ""
                  }
                />
              </ViewTableWrapper.Content>
            </ViewTableWrapper>
          </Box>
        </CardContent>
      </Card>
    </PageWrapper>
  );
};
export default CandidateManagementCalenderView;
